<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    상품관리
                    <el-button class="title_btn" @click="openModal('product-write-modal')" type="primary">상품등록</el-button>
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_payment_detail active"

                    >
                        결제상품
                    </div>
                    <div class="write_tab_content tab_payment_detail"
                         @click="movePage(`/service/product/service`)"
                    >
                        서비스 이용요금
                    </div>

                </div>
                <div class="list-content">
                    <point-list-component point-type="product"></point-list-component>
                </div>
            </div>
        </div>
        <product-write-modal></product-write-modal>
    </div>
</template>

<script>
import PointListComponent from "@/components/point/PointListComponent";
import ProductWriteModal from "@/components/modal/ProductWriteModal";

export default {
  name: "ProductManagement",
  mixins: [],
  components: {
      ProductWriteModal,
      PointListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      movePage(url){
          this.$router.push(url)
      },
      openModal(name) {
          this.$modal.show(name);
      },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
